import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import {
	getServiceDeskNavigationResources,
	getServicedeskPageContextResources,
} from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { servicedeskSurveysRoute } from '@jira/router-routes__servicedesk-surveys-routes/src/servicedeskSurveysRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
// eslint-disable-next-line jira/restricted/@jira+servicedesk__common-toPackageName
import { APP_NAMES, toPackageName } from '@jira/servicedesk__common/src/toPackageName.tsx';
import { surveysPageEntryPoint } from './ui/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const servicedeskSurveysRouteEntry: Route = createEntry(servicedeskSurveysRoute, () => ({
	group: 'servicedesk',
	ufoName: 'jsm.surveys',
	navigation: {
		menuId: MenuIdProjects,
	},
	layout: serviceProjectLayout,
	resources: [
		...getServiceDeskNavigationResources(),
		...getServicedeskPageContextResources(),
		getConsolidationStateResource(),
	],
	entryPoint: () => surveysPageEntryPoint,
	meta: {
		reporting: {
			id: 'surveys',
			packageName: toPackageName(APP_NAMES.SURVEYS),
			teamName: 'jsm-phoenix',
		},
	},
	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
